import EditMusicSyncContainer from "../containers/EditMusicSyncContainer";

const EditMusicSyncPage = () => {
  return (
    <EditMusicSyncContainer />
  );
};

export default EditMusicSyncPage;
